
  import {
    Vue,
    Component,
    Watch,
  } from 'vue-property-decorator';
  import Message from '@/components/message.vue';
  import changePsd from "@/components/changePsd.vue"
  import {
    AppModule
  } from '../../../store/modules/app';
  import { removeUserInfo, removeUserId, getUserInfo } from '@/utils/storage';
  import { RoleData } from '@/utils/config';
  import {imgHost} from '@/utils/config';
  
	import {
		UserModule
	} from "@/store/modules/user"
  import store from '@/store'
  @Component({
    name: 'navbar',
    components: {
      'slz-message': Message,
      'change-psd':changePsd
    },
  })
  export default class Navbar extends Vue {
    private imgurl = imgHost
    private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
    private routeNameList: any[] = []
    private showMessage = false
    private showDialog = false
    private canclose = true
    private roles = RoleData
    @Watch('$route')
    routeChange(to: any, from: any) {
      this.getRouteName();
    }
    private get psdEasy(){
      return UserModule.psdEasy
      // return true
    }
    private set psdEasy(v){
      store.dispatch('setPsdEasy', false)
    }
    private get userInfo() {
      // console.log(this.roles,getUserInfo())
      return getUserInfo()
    }

    private created() {
      this.getRouteName();
    }
    private mounted () {

    }


    private mandatory(){
      this.showDialog = true
      this.canclose = false
    }
    /**
     * 获取路由名
     */
    private getRouteName() {
      this.routeNameList = this.$route.matched.map((item: any) => {
        return {
          title: item.meta.title,
          name: item.name || ''
        };
      })
    }

    /**
     * 控制sidebar开关
     */
    private handleOpen() {
      AppModule.ToggleSideBar()
    }

    /**
     * 退出登录
     */
    private doLogout() {
      this.showMessage = true;
    }

    /**
     * 确认登出
     */
    private handleConfirm() {
      removeUserId();
      removeUserInfo();
      location.reload()
    }

    private reqLogout() {
      console.log('登出请求');
    }
  }
